class UgcCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    this.checkUgcLoaded()
  }

  checkUgcLoaded () {
    this.yotpoInterval = setInterval(() => {
      const slidesEl = this.querySelector(
        '.yotpo-pictures-gallery-images-wrapper',
      )

      if (slidesEl) {
        const slideEls = this.querySelectorAll('.yotpo-single-image-container')

        slidesEl.classList.add('keen-slider')
        slideEls.forEach(el => el.classList.add('keen-slider__slide'))

        clearInterval(this.yotpoInterval)
        this.carousel = this.setupCarousel()
      }
    }, 500)
  }

  setupCarousel () {
    const slidesEl = this.querySelector(
      '.yotpo-pictures-gallery-images-wrapper',
    )
    this.removeAttribute('aria-hidden')

    return new window.KeenSlider(
      slidesEl,
      {
        selector: '.yotpo-single-image-container',
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.5,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3,
              spacing: 10,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4,
              spacing: 30,
            },
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('ugc-carousel')) {
  customElements.define('ugc-carousel', UgcCarousel)
}
